import { Injector } from "@angular/core";
import { environment } from "../../../../../environments/environment";
import { MedicinalproductsService } from "../../../service/medicinalproducts-service/medicinalproducts.service";
import { Art57Section } from "../../Art57Section/Art57Section";
import { QueryResultNode } from "../QueryResultNode";
import { DateUtil } from "../../DateUtil";
import { QueryConditionsNode } from "../QueryConditionsNode";
import { QueryFieldsNode } from "../QueryFieldsNode";

export class MedicinalProductsQueryResultNode extends QueryResultNode {
    constructor(injector: Injector, data: any, labelTemplate: string, entityName: string,fieldsNode: QueryFieldsNode|null,conditionsNode:QueryConditionsNode|null) {
      super(injector,data,labelTemplate,entityName, fieldsNode, conditionsNode, []);
    }
    
    exportToExcel(){
        this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Exporting records to Excel file...', life: environment.successElapsedTime });
        //US-328923: To export to Excel only the selected items in Active Area results
        let model:[] = this.data.model.filter((item: any) => item.checked);
        if (model.length == 0) {
          model = this.data.model;
        }
        
        this.ioc!.get(MedicinalproductsService).exportResultsToExcel(this.entityName, model, this.paginationControl.fields)
          .subscribe({
            next: (response: any) => {
              const contentDisposition = response.headers.get('content-disposition');
              const filename = contentDisposition.match(/filename=(.+)$/)[1].replace(/['"]/, '').trim();
              const url = window.URL.createObjectURL(response.body as Blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = filename;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
              this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Exporting records to Excel finished', life: environment.successElapsedTime });
            },
            error: (error: any) => {
              this.ioc!.get(Art57Section).showTooltipMessage({
                severity: 'error',
                detail: 'Error found',
                life: environment.errorElapsedTime,
              });
            },
          });
      }
}